export const colors = [
    '#001219',
    '#005f73',
    '#0a9396',
    '#94d2bd',
    '#e9d8a6',
    '#ee9b00',
    '#ca6702',
    '#bb3e03',
    '#9b2226',
]

export const reportGridsSx = {
    bgcolor: 'background.paper',
    "& .MuiDataGrid-columnHeaderTitle": {
        whiteSpace: "normal",
        lineHeight: "normal"
    },
    "& .MuiDataGrid-columnHeader": {
        // Forced to use important since overriding inline styles
        height: "unset !important"
    },
    "& .MuiDataGrid-columnHeaders": {
        // Forced to use important since overriding inline styles
        maxHeight: "200px !important",
        minHeight: "80px !important",
        textAlign: 'right'
    }
}